// extracted by mini-css-extract-plugin
module.exports = {"answers":"_398sDzregv4P8lnceRQ5cN"};